// extracted by mini-css-extract-plugin
export default {"verti_header":"CustomBoardHeader_verti_header__0KSr6","hori_header_list":"CustomBoardHeader_hori_header_list__047rs","hori_header_card":"CustomBoardHeader_hori_header_card__hHXrB"};